type MockHandler = (body: unknown) => Promise<unknown>;

const handlers = new Map<string, Map<string, MockHandler>>();

export function registerMockHandler(
  method: string,
  path: string,
  handler: MockHandler
): void {
  const key = method.toUpperCase();
  if (!handlers.has(key)) {
    handlers.set(key, new Map());
  }
  handlers.get(key)!.set(path, handler);
}

export function getMockHandler(
  method: string,
  path: string
): MockHandler | undefined {
  return handlers.get(method.toUpperCase())?.get(path);
}
